import { useDoubleContractKlineStore } from '../stores/use-double-contract-kline'
import { useKlineStore } from '../stores/use-kline'

export const useChangeSymbol = (fn: (currentSymbolId: SymbolId, oldSymbolId?: SymbolId) => void, options?: { immediate?: boolean }) => {
  const klineStore = useKlineStore()

  watch(
    () => klineStore.currentSymbolId,
    (currentSymbolId, oldSymbolId) => {
      if (currentSymbolId) {
        fn(currentSymbolId, oldSymbolId)
      }
    },
    {
      immediate: true,
      ...options,
    },
  )
}

export const useContractChangeSymbol = (fn: (currentSymbolId: SymbolId, oldSymbolId?: SymbolId) => void, options?: { immediate?: boolean }) => {
  const doubleContractKlineStore = useDoubleContractKlineStore()

  watch(
    () => doubleContractKlineStore.currentSymbolId,
    (currentSymbolId, oldSymbolId) => {
      if (currentSymbolId) {
        fn(currentSymbolId, oldSymbolId)
      }
    },
    {
      immediate: true,
      ...options,
    },
  )
}
